import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _indexOf from 'lodash/indexOf';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Models
import mSource from 'models/source';
// Custom
import { deviceSlaveInputDataShape, sourceDataShape } from 'constants/PropTypesShapes';
import SourceItem from 'installations/assets/configuration/SourceItem';

class ConfigureDeviceSlaveInput extends React.Component {
  constructor(props) {
    super(props);

    this.handleSourceChange = this.handleSourceChange.bind(this);
  }

  // Handlers
  handleSourceChange(source) {
    const { input: { sources } } = this.props;
    // Try to find source id in input sources
    const sourceIndex = _indexOf(sources, source.id);
    let newSources = [];
    if (sourceIndex === -1) {
      newSources = [...sources, source.id];
    } else {
      newSources = [...sources.slice(0, sourceIndex), ...sources.slice(sourceIndex + 1)];
    }
    this.doHandleSourceChange(newSources);
  }

  // Private
  doHandleSourceChange(sources) {
    const { input, onInputSourceChange } = this.props;
    onInputSourceChange(input, sources);
  }

  render() {
    const { input, installationSources } = this.props;
    const { sources } = input;
    const sortedSources = mSource.sortElements(installationSources);

    return (
      <div className="box box-default m-0">
        <div className="box-header box-dark">
          <LocalizedMessage id="info.input" values={{ input: input.code }} />
        </div>
        <div className="px-3">
          {_isEmpty(sortedSources) && (
            <div className="pt-3">
              <em><LocalizedMessage id="info.installationNoSource" /></em>
            </div>
          )}
          <div className="row pb-3">
            {!!installationSources && _map(sortedSources, (source) => (
              <div key={_toString(source.id)} className="col-12">
                <SourceItem
                  source={source}
                  toggle={
                    { toggled: _includes(sources, source.id), onToggle: () => this.handleSourceChange(source) }
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

ConfigureDeviceSlaveInput.propTypes = {
  input: deviceSlaveInputDataShape.isRequired,
  installationSources: PropTypes.arrayOf(sourceDataShape),
  onInputSourceChange: PropTypes.func.isRequired,
};

ConfigureDeviceSlaveInput.defaultProps = {
  installationSources: null,
};

const mapStateToProps = (state) => ({
  installationSources: state.installationSource.list.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(ConfigureDeviceSlaveInput);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/ConfigureDeviceSlaveInput.js